const getSMSSubscriptionAttributes = (
  smsSubscriptionStatusArg,
  saPhoneNumber,
  formatMessage,
) => {
  switch (smsSubscriptionStatusArg) {
    case 'UNSUBSCRIBED':
      return {
        color: 'error',
        title: formatMessage({
          id: 'UNSUBSCRIBED',
          defaultMessage: 'Unsubscribed',
        }),
        detail: saPhoneNumber
          ? formatMessage(
              {
                id: 'SMS_UNSUBSCRIBED_DETAIL',
                defaultMessage:
                  'SMS delivery is blocked. The user must text START to {saPhoneNumber} to re-enable SMS.',
              },
              { saPhoneNumber },
            )
          : formatMessage({
              id: 'SMS_UNSUBSCRIBED_DETAIL_NO_PHONE',
              defaultMessage:
                'SMS delivery is blocked. The user must text START to the phone number to re-enable SMS.',
            }),
      };
    case 'SUBSCRIBED':
      return {
        color: 'success',
        title: formatMessage({
          id: 'SUBSCRIBED',
          defaultMessage: 'Subscribed',
        }),
        detail: formatMessage({
          id: 'SMS_SUBSCRIBED_DETAIL',
          defaultMessage:
            'Fully opted in and eligible to receive SMS notifications.',
        }),
      };
    case 'PENDING':
      return {
        color: 'warning',
        title: formatMessage({
          id: 'PENDING_VERIFICATION',
          defaultMessage: 'Pending Verification',
        }),
        detail: saPhoneNumber
          ? formatMessage(
              {
                id: 'SMS_PENDING_VERIFICATION_DETAIL',
                defaultMessage:
                  "Opt-in process is not complete. A verification SMS has been sent and is awaiting the user's response. The user can text START to {saPhoneNumber} to verify.",
              },
              { saPhoneNumber },
            )
          : formatMessage({
              id: 'SMS_PENDING_VERIFICATION_DETAIL_NO_PHONE',
              defaultMessage:
                "Opt-in process is not complete. A verification SMS has been sent and is awaiting the user's response. The user can text START to the phone number to verify.",
            }),
      };
    case 'OPTED_OUT':
      return {
        color: 'default',
        title: formatMessage({
          id: 'SMS_OPTED_OUT',
          defaultMessage: 'Opted Out',
        }),
        detail: formatMessage(
          {
            id: 'SMS_OPTED_OUT_DETAIL',
            defaultMessage:
              'User opted out of SMS during verification. Messages will not be sent. User can text INFO to {saPhoneNumber} to restart the Opt-In verification process.',
          },
          { saPhoneNumber },
        ),
      };
    default:
      return {
        color: 'default',
        title: smsSubscriptionStatusArg,
        detail: smsSubscriptionStatusArg,
      };
  }
};

export default getSMSSubscriptionAttributes;
